import React, { Component } from "react";
import { StudioSectionHeader, StudioFoldControl } from "./InstagramUnifiedStudioParts";
import http from "../modules/api";
import AiVideoStudioWorkflowClass from "../modules/common/AiVideoStudioWorkflowClass";
import TitleContentDialogV2 from "../modules/dialogs/TitleContentDialogV2";
import SaveDialogV2 from "../modules/dialogs/SaveDialogV2";

const AI_VIDEO_STUDIO_GALLERY_LIST_URL = "/rest/shop/aiVideoStudio/galleryList";
const AI_VIDEO_STUDIO_GALLERY_HIDE_URL = "/rest/shop/aiVideoStudio/galleryResult/hide";
const AI_VIDEO_STUDIO_HISTORY_PAGE_SIZE = 24;
const INSTAGRAM_CREATE_POST_URL = "/shop/instagram/InstagramCreatePost";
const AI_VIDEO_STUDIO_APPLY_VIDEO_STORAGE_KEY = "instagram_ai_video_studio_apply_video";
const SAMPLE_IMAGE_ROOT = "https://s3.ap-northeast-2.amazonaws.com/otdeal.file/veo_sample_image/";
const SAMPLE_GIF_ROOT = "https://s3.ap-northeast-2.amazonaws.com/otdeal.file/vedio_sample/";
const RECOMMEND_VISIBLE_COUNT_STEP = 6;

const MINIATURE_SAMPLE_PROMPT = `제품이 거대한 오브젝트처럼 보이는 미니어처 세계 광고 영상을 만든다.

아주 작은 미니어처 사람들이 제품 주변을 걸어 다니거나 사다리를 이용해 올라가고,
공구와 작업 장비를 활용해 제품을 살펴보거나 관리하는 듯한 자연스러운 움직임을 보여준다.

작업자들의 행동은 서로 조금씩 다르게 표현하여 작은 작업 현장이 실제로 움직이는 듯한 생동감을 만든다.

정교한 미니어처 디오라마와 실제 제품 촬영이 자연스럽게 결합된 듯한 현실적인 분위기로 연출한다.

입력 이미지에서 확인되는 제품의 형태, 색상과 주요 디자인 특징을 유지한다.
입력 이미지에 없는 문자, 브랜드 요소 또는 새로운 제품 디자인을 임의로 추가하지 않는다.`.trim();

const SHOW_HOST_SAMPLE_PROMPT = `세로형 SNS 릴스 스타일의 현실적인 제품 소개 영상.

제공된 쇼호스트와 촬영 공간의 외형, 얼굴, 헤어스타일, 의상, 조명과 전체 분위기를 영상 시작부터 끝까지 일관되게 유지한다.

사용자가 제공한 제품 이미지를 실제 판매 제품으로 사용한다. 제품은 쇼호스트 옆의 진열대 위에 자연스럽게 배치하며, 원래 제품의 형태, 색상, 재질, 패키지 디자인과 주요 특징을 최대한 정확하게 유지한다. 제품을 임의로 변형하거나 새로운 문자, 로고, 장식 요소를 추가하지 않는다.

쇼호스트는 제품을 직접 들거나 가리지 않고, 카메라를 바라보면서 제품을 자연스럽게 가리키거나 소개하는 작은 손동작을 한다.

쇼호스트는 제공된 제품 정보와 사용자의 요청을 바탕으로 해당 제품에 어울리는 자연스러운 한국어 소개 멘트를 직접 구성해서 말한다.

멘트는 8초 안에 자연스럽게 말할 수 있도록 매우 짧게 구성하고, 제품의 가장 매력적인 특징 한 가지를 중심으로 소개한다. 매번 동일한 시작 문구나 문장 구조를 반복하지 않고 실제 SNS 쇼호스트가 자연스럽게 제품을 추천하는 것처럼 표현한다.

상품 정보에 없는 효능, 성능, 가격, 할인, 혜택 또는 특징을 임의로 만들어내지 않는다.

과장된 홈쇼핑 말투보다는 친근하고 밝은 SNS 릴스 크리에이터의 말투를 사용한다. 말하는 동안 자연스러운 입 모양과 작은 표정 변화만 사용하고 과장된 몸짓이나 빠른 움직임은 사용하지 않는다.

카메라는 정면 구도에서 고정한다. 줌, 카메라 이동, 장면 전환, 컷 변경 또는 다른 장소로의 전환 없이 하나의 연속된 장면으로 구성한다.

실제 스마트폰으로 촬영한 고품질 SNS 제품 광고처럼 자연스러운 피부 질감, 현실적인 조명과 그림자, 깔끔하고 세련된 상업용 릴스 분위기로 표현한다.

영상 길이는 정확히 8초다.`.trim();

const COOKING_SAMPLE_PROMPT = `PRIMARY USER REQUEST:
제공된 재료 이미지를 중심으로 만드는 현실적인 세로형 SNS 숏폼 요리 영상.

입력된 재료를 메인 재료로 사용하고,
해당 재료와 가장 자연스럽고 일반적으로 잘 어울리는 요리를 영상 안에서 자동으로 구성한다.
특정 레시피를 미리 고정하지 말고, 재료의 특성에 맞는 가장 적절 요리 방식으로 표현한다.

영상은 다음 흐름으로 자연스럽게 진행한다.
처음에는 재료 자체가 신선하고 먹음직스럽게 보이도록 보여주고,
이후 손질하거나 써는 장면,
재료와 잘 어울리는 보조 재료를 함께 활용하는 간단한 조리 장면,
마지막에는 완성된 요리가 맛있어 보이게 담긴 장면으로 마무리한다.

요리는 실제로 있을 법하고 대중적으로 자연스러운 메뉴여야 하며,
입력 재료가 가장 돋보이도록 구성한다.
입력 재료가 생으로 먹기 좋은 식재료라면 샐러드, 플레이팅, 간단한 조합 요리로 표현할 수 있고,
익혀 먹는 재료라면 볶음, 구이, 조림, 수프, 면 요리 등 자연스러운 방식으로 표현한다.

영상의 중심은 제공된 재료이며,
재료의 형태, 색감, 신선한 인상이 과도하게 변형되지 않도록 유지한다.
전체 분위기는 실제 푸드 광고 또는 레시피 숏폼처럼 자연스럽고 먹음직스럽게 표현한다.
사람 얼굴, 문자, 로고, 과한 화면 전환, 불필요한 장식은 넣지 않는다.

[오디오 강제 제어 명령 - 최우선 적용]
이 지시사항은 하단에 고정된 [PRODUCTION GUIDANCE]의 모든 Audio 관련 명령보다 무조건 최우선으로 적용된다.
CRITICAL SYSTEM OVERRIDE: 
Ignore all audio-related instructions in the "PRODUCTION GUIDANCE" below. 
Generate NO ambient sound, AND NO sound effects, AND NO spoken dialogue. 
The output video MUST be 100% SILENT. This instruction takes absolute priority over everything else.`.trim();

const RECOMMEND_VIDEO_LIST = [
  {
    sort_no: 1,
    title: "수분크림 뷰티 광고",
    src: SAMPLE_GIF_ROOT + "51972dc5-c22b-4431-b273-2179f3817760-_1_.gif",
    input_src: SAMPLE_IMAGE_ROOT + "1.beauty.png",
    alt: "수분크림 뷰티 광고",
    scene_description: "제품을 중심으로 물방울과 반사광, 촉촉한 수분감을 살린 뷰티 광고 영상입니다.",
    image_guide: "샘플 시작 이미지가 적용되어 있습니다.",
    prompt: "촉촉하고 쫀쫀한 수분크림 광고 영상. 제품은 화면의 중심에 선명하게 유지되고, 주변의 빛과 공기, 반사광, 물 느낌이 자연스럽게 살아난다. 작은 물방울과 수분감이 은은하게 강조되고, 제품의 촉촉함과 고급스러운 스킨케어 분위기가 느껴진다. 광고 영상처럼 자연스럽고 세련되게 진행된다.",
    prompt_placeholder: "추가 요청이 있다면 입력해 주세요. 입력하지 않아도 제작할 수 있어요.\n예: 전체 색감을 연한 민트톤으로 표현",
    video_style_cd: "BEAUTY_AD",
    camera_angle_cd: "CLOSE_UP",
    camera_movement_cd: "ORBIT",
    aspect_ratio: "9:16",
    duration_seconds: 8,
    resolution: "720p",
  },
  {
    sort_no: 2,
    title: "향수 프리미엄 광고",
    src: SAMPLE_GIF_ROOT + "dde6bb5a-5c4d-4847-b81b-0de49afdb869-_1_-_1_.gif",
    input_src: SAMPLE_IMAGE_ROOT + "2.perfume.png",
    alt: "향수 프리미엄 광고",
    scene_description: "향수병의 유리 질감과 반사광을 강조한 고급스럽고 럭셔리한 제품 광고 영상입니다.",
    image_guide: "샘플 시작 이미지가 적용되어 있습니다.",
    prompt: "고급 향수 광고 영상. 향수병은 화면의 중심에서 선명하게 유지되고, 빛과 반사, 분위기 있는 공기감이 점점 살아난다. 유리 재질과 제품의 윤곽이 고급스럽게 드러나고, 카메라가 천천히 제품을 강조한다. 세련되고 럭셔리한 브랜드 광고 분위기로 자연스럽게 진행된다.",
    prompt_placeholder: "추가 요청이 있다면 입력해 주세요. 입력하지 않아도 제작할 수 있어요.\n예: 제품 주변에 검은 패브릭과 금속 오브제를 배치",
    video_style_cd: "PRODUCT_AD",
    camera_angle_cd: "LOW",
    camera_movement_cd: "DOLLY_IN",
    aspect_ratio: "9:16",
    duration_seconds: 8,
    resolution: "720p",
  },
  {
    sort_no: 3,
    title: "베이커리 음식 광고",
    src: SAMPLE_GIF_ROOT + "4e166653-aae0-494f-817d-24570d9f8cf6-_1_.gif",
    input_src: SAMPLE_IMAGE_ROOT + "3.bakery.png",
    alt: "베이커리 음식 광고",
    scene_description: "따뜻한 아침 햇빛과 은은한 김으로 음식의 바삭함과 온기를 살린 광고 영상입니다.",
    image_guide: "샘플 시작 이미지가 적용되어 있습니다.",
    prompt: "따뜻하고 먹음직스러운 베이커리 광고 영상. 크루아상과 커피가 화면의 중심에 자연스럽게 유지되고, 따뜻한 아침 햇빛과 은은한 김이 살아난다. 음식의 바삭한 질감과 따뜻한 분위기가 강조되며, 카메라는 천천히 음식 쪽으로 다가간다. 자연스럽고 현실적인 음식 광고처럼 진행된다.",
    prompt_placeholder: "추가 요청이 있다면 입력해 주세요. 입력하지 않아도 제작할 수 있어요.\n예: 접시 주변에 버터와 작은 베리류를 자연스럽게 추가",
    video_style_cd: "REALISTIC",
    camera_angle_cd: "CLOSE_UP",
    camera_movement_cd: "DOLLY_IN",
    aspect_ratio: "9:16",
    duration_seconds: 8,
    resolution: "720p",
  },
  {
    sort_no: 4,
    title: "패션 숏폼",
    src: SAMPLE_GIF_ROOT + "dea3fbe0-e794-4c96-a0e8-88e6dbc16164-_1_.gif",
    input_src: SAMPLE_IMAGE_ROOT + "4.fashion.png",
    alt: "패션 숏폼",
    scene_description: "모델이 천천히 몸을 돌며 착장의 실루엣과 소재감을 보여주는 패션 숏폼 영상입니다.",
    image_guide: "샘플 시작 이미지가 적용되어 있습니다.",
    prompt: "세련된 패션 숏폼 광고 영상. 모델은 자연스럽게 서 있다가 천천히 몸을 돌려 착장의 실루엣을 보여준다. 옷의 핏과 소재감이 잘 보이고, 카메라는 부드럽게 움직이며 전체 코디를 세련되게 강조한다. 짧고 감각적인 패션 브랜드 숏폼 영상처럼 진행된다.",
    prompt_placeholder: "추가 요청이 있다면 입력해 주세요. 입력하지 않아도 제작할 수 있어요.\n예: 도시적인 런웨이 느낌의 분위기로 표현",
    video_style_cd: "SNS_SHORT",
    camera_angle_cd: "FRONT",
    camera_movement_cd: "PAN",
    aspect_ratio: "9:16",
    duration_seconds: 8,
    resolution: "720p",
  },
  {
    sort_no: 5,
    title: "시네마틱 장면",
    src: SAMPLE_GIF_ROOT + "267a8c23-5208-40f3-861c-f436921834fe-_1_.gif",
    input_src: SAMPLE_IMAGE_ROOT + "5.cinema.png",
    alt: "시네마틱 장면",
    scene_description: "비가 갠 밤 골목에서 인물과 빛, 젖은 노면의 분위기를 살린 시네마틱 영상입니다.",
    image_guide: "샘플 시작 이미지가 적용되어 있습니다.",
    prompt: "영화 같은 시네마틱 영상. 비가 갠 밤의 골목에서 인물과 주변 공기, 빛, 반사된 노면이 자연스럽게 살아난다. 인물은 천천히 움직이거나 걷고, 공간의 깊이와 분위기가 점점 살아난다. 영화의 한 장면처럼 몰입감 있고 감성적인 분위기로 자연스럽게 진행된다.",
    prompt_placeholder: "추가 요청이 있다면 입력해 주세요. 입력하지 않아도 제작할 수 있어요.\n예: 골목의 네온사인을 푸른색과 보라색 계열로 표현",
    video_style_cd: "CINEMATIC",
    camera_angle_cd: "LOW",
    camera_movement_cd: "DOLLY_OUT",
    aspect_ratio: "9:16",
    duration_seconds: 8,
    resolution: "720p",
  },
  {
    sort_no: 6,
    title: "귀여운 피규어 숏폼",
    src: SAMPLE_GIF_ROOT + "efa90ce2-f1a5-4676-bf23-d600a7e32257-_1_.gif",
    input_src: SAMPLE_IMAGE_ROOT + "6.Cute_figure.png",
    alt: "귀여운 피규어 숏폼",
    scene_description: "캐릭터 피규어의 디자인을 유지하면서 주변 소품과 빛에 자연스러운 움직임을 더한 숏폼 영상입니다.",
    image_guide: "샘플 시작 이미지가 적용되어 있습니다.",
    prompt: `귀엽고 매력적인 캐릭터 피규어를 돋보이게 보여주는 SNS 숏폼 제품 영상.
시작 이미지에 있는 캐릭터 피규어의 얼굴, 표정, 색상, 의상, 액세서리와 전체적인 디자인을 자연스럽게 유지한다.
피규어가 영상의 주인공으로 명확하게 보이도록 연출하며, 캐릭터의 입체적인 형태와 귀여운 디테일이 잘 드러난다.
주변 소품과 배경에는 자연스럽고 미세한 움직임을 더하고, 빛과 그림자가 부드럽게 변화하면서 정적인 사진이 생동감 있는 영상으로 자연스럽게 이어진다.
캐릭터의 형태가 과도하게 변형되거나 새로운 신체 요소가 생기지 않도록 유지하고, 전체적으로 밝고 사랑스러우며 시선을 끄는 캐릭터 굿즈 광고 영상처럼 연출한다.`.trim(),
    prompt_placeholder: "추가 요청이 있다면 입력해 주세요. 입력하지 않아도 제작할 수 있어요.\n예: 피규어 주변에 작은 별 모양 소품을 추가",
    video_style_cd: "SNS_SHORT",
    camera_angle_cd: "FRONT",
    camera_movement_cd: "ORBIT",
    aspect_ratio: "9:16",
    duration_seconds: 8,
    resolution: "720p",
  },
  {
    sort_no: 7,
    title: "미니어처 세상 속 제품",
    src: SAMPLE_GIF_ROOT + "0bf80351-6423-440c-98b1-66c1d90bf9cb (1).mp4",
    alt: "미니어처 세상 속 제품",
    scene_description: "제품이 거대한 오브젝트가 되고 작은 작업자들이 주변에서 움직이는 미니어처 광고 영상입니다.",
    user_reference_image: {
      required: true,
      min_count: 1,
      max_count: 1,
      image_guide: "준비물은 제품 이미지 1장이면 충분해요.",
      image_description: "영상 속 거대한 오브젝트로 표현할 실제 제품 이미지",
      add_label: "제품 이미지 추가",
      slot_label: "제품 이미지",
      image_validation_message: "제품 이미지 1장을 추가해 주세요.",
      input_fields: [
        { key: "product_type", label: "제품 종류", type: "text", required: true, placeholder: "예: 남성 구두", max_length: 999 }
      ],
      description_template: "{product_type}",
    },
    reference_images: [
      {
        image_url: SAMPLE_GIF_ROOT + "output_1787042713737_8877.png", // TODO: 미니어처 공방 배경 및 소품 참조 이미지 S3 URL
        file_name: "미니어처 공방 배경 및 소품 참조 이미지",
        description: "미니어처 공방의 배경, 작업 공간, 소품과 전체적인 디오라마 분위기를 참고하는 이미지",
      },
      {
        image_url: SAMPLE_GIF_ROOT + "output_1787043142318_2523.png", // TODO: 미니어처 작업 연출 참조 이미지 S3 URL
        file_name: "미니어처 작업 연출 참조 이미지",
        description: "작은 미니어처 작업자들이 제품 주변에서 걷고 사다리와 공구를 활용해 작업하는 연출을 참고하는 이미지",
      },
    ],
    prompt: MINIATURE_SAMPLE_PROMPT,
    prompt_placeholder: "추가 요청이 있다면 입력해 주세요. 입력하지 않아도 제작할 수 있어요.\n예: 작업자들이 제품 표면을 닦거나 측정 도구로 세밀하게 점검하는 모습을 추가",
    video_style_cd: "SNS_SHORT",
    camera_angle_cd: "CLOSE_UP",
    camera_movement_cd: "DOLLY_OUT",
    aspect_ratio: "9:16",
    duration_seconds: 8,
    resolution: "1080p",
  },
  {
    sort_no: 8,
    title: "AI 쇼호스트 - 여성 상반신",
    src: "https://s3.ap-northeast-2.amazonaws.com/otdeal.file/robo_instagram/veo/2026/08/25/a7af7e15-74f2-4e75-8d14-0de26b88b0dd.mp4",
    alt: "AI 쇼호스트 여성",
    scene_description: "여성 AI 쇼호스트가 제품을 가리키며 짧은 한국어 멘트로 소개하는 SNS 릴스 영상입니다.",
    user_reference_image: {
      required: true,
      min_count: 1,
      max_count: 1,
      image_guide: "준비물은 제품 이미지 1장이면 충분해요.",
      image_description: "쇼호스트가 소개할 실제 판매 제품 이미지",
      add_label: "제품 이미지 추가",
      slot_label: "제품 정보",
      image_validation_message: "제품 이미지 1장을 추가해 주세요.",
      field_validation_message: "제품 종류, 제품명, 제품 특징을 모두 입력해 주세요.",
      input_fields: [
        { key: "product_type", label: "제품 종류", type: "text", required: true, placeholder: "예: 무선 이어폰", max_length: 999 },
        { key: "product_name", label: "제품명", type: "text", required: true, placeholder: "예: 클리어 버즈 프로", max_length: 999 },
        { key: "product_description", label: "제품 특징", type: "text", required: true, placeholder: "예: 노이즈 캔슬링과 선명한 통화를 지원", max_length: 999 },
      ],
      description_template: "제품 종류: {product_type} / 제품명 : {product_name} / 제품 특징 : {product_description}",
    },
    reference_images: [
      {
        image_url: "https://s3.ap-northeast-2.amazonaws.com/otdeal.file/genai/output/output_1787300886688_2528.png", // TODO: 여성 쇼호스트 참조 이미지 S3 URL
        file_name: "여성 쇼호스트 참조 이미지",
        description: "제품을 소개하는 여성 AI 쇼호스트의 얼굴, 헤어스타일, 의상, 촬영 공간, 조명과 전체 분위기를 참고하는 이미지",
      },
    ],
    prompt: SHOW_HOST_SAMPLE_PROMPT,
    prompt_placeholder: "추가 요청이 있다면 입력해 주세요. 입력하지 않아도 제작할 수 있어요.\n예: 제품의 가장 큰 장점을 강조하면서 밝고 친근한 말투로 소개",
    video_style_cd: "SNS_SHORT",
    camera_angle_cd: "FRONT",
    camera_movement_cd: "STATIC",
    aspect_ratio: "9:16",
    duration_seconds: 8,
    resolution: "1080p",
  },
  {
    sort_no: 9,
    title: "AI 쇼호스트 - 남성 상반신",
    src: SAMPLE_GIF_ROOT + "f9d23d40-cb1f-4970-b91e-bcb287099c09.mp4",
    alt: "AI 쇼호스트 남성",
    scene_description: "남성 AI 쇼호스트가 제품을 가리키며 짧은 한국어 멘트로 소개하는 SNS 릴스 영상입니다.",
    user_reference_image: {
      required: true,
      min_count: 1,
      max_count: 1,
      image_guide: "준비물은 제품 이미지 1장이면 충분해요.",
      image_description: "쇼호스트가 소개할 실제 판매 제품 이미지",
      add_label: "제품 이미지 추가",
      slot_label: "제품 정보",
      image_validation_message: "제품 이미지 1장을 추가해 주세요.",
      field_validation_message: "제품 종류, 제품명, 제품 특징을 모두 입력해 주세요.",
      input_fields: [
        { key: "product_type", label: "제품 종류", type: "text", required: true, placeholder: "예: 무선 이어폰", max_length: 999 },
        { key: "product_name", label: "제품명", type: "text", required: true, placeholder: "예: 클리어 버즈 프로", max_length: 999 },
        { key: "product_description", label: "제품 특징", type: "text", required: true, placeholder: "예: 노이즈 캔슬링과 선명한 통화를 지원", max_length: 999 },
      ],
      description_template: "제품 종류: {product_type} / 제품명 : {product_name} / 제품 특징 : {product_description}",
    },
    reference_images: [
      {
        image_url: "https://s3.ap-northeast-2.amazonaws.com/otdeal.file/genai/output/output_1787302709626_6545.png", // TODO: 남성 쇼호스트 참조 이미지 S3 URL
        file_name: "남성 쇼호스트 참조 이미지",
        description: "제품을 소개하는 남성 AI 쇼호스트의 얼굴, 헤어스타일, 의상, 촬영 공간, 조명과 전체 분위기를 참고하는 이미지",
      },
    ],
    prompt: SHOW_HOST_SAMPLE_PROMPT,
    prompt_placeholder: "추가 요청이 있다면 입력해 주세요. 입력하지 않아도 제작할 수 있어요.\n예: 제품의 사용 편의성을 중심으로 자연스럽고 담백하게 소개",
    video_style_cd: "SNS_SHORT",
    camera_angle_cd: "FRONT",
    camera_movement_cd: "STATIC",
    aspect_ratio: "9:16",
    duration_seconds: 8,
    resolution: "1080p",
  },
  {
    sort_no: 10,
    title: "AI 쇼호스트 - 여성 전신",
    src: SAMPLE_GIF_ROOT + "ab84bb84-6a74-46e0-bca3-9609c5928496.mp4",
    alt: "AI 쇼호스트 큰 제품",
    scene_description: "쇼호스트가 비교적 큰 제품 옆에 서서 짧은 한국어 멘트로 소개하는 SNS 릴스 영상입니다.",
    user_reference_image: {
      required: true,
      min_count: 1,
      max_count: 1,
      image_guide: "준비물은 제품 이미지 1장이면 충분해요.",
      image_description: "쇼호스트가 소개할 비교적 큰 실제 판매 제품 이미지",
      add_label: "제품 이미지 추가",
      slot_label: "제품 정보",
      image_validation_message: "제품 이미지 1장을 추가해 주세요.",
      field_validation_message: "제품 종류, 제품명, 제품 특징을 모두 입력해 주세요.",
      input_fields: [
        { key: "product_type", label: "제품 종류", type: "text", required: true, placeholder: "예: 무선 이어폰", max_length: 999 },
        { key: "product_name", label: "제품명", type: "text", required: true, placeholder: "예: 클리어 버즈 프로", max_length: 999 },
        { key: "product_description", label: "제품 특징", type: "text", required: true, placeholder: "예: 노이즈 캔슬링과 선명한 통화를 지원", max_length: 999 },
      ],
      description_template: "제품 종류: {product_type} / 제품명 : {product_name} / 제품 특징 : {product_description}",
    },
    reference_images: [
      {
        image_url: "http://s3.ap-northeast-2.amazonaws.com/otdeal.file/genai/output/output_1787549541087_5536.png", // TODO: 서서 설명하는 쇼호스트 참조 이미지 S3 URL
        file_name: "서서 설명하는 쇼호스트 참조 이미지",
        description: "비교적 큰 제품을 옆에 두고 서서 소개하는 AI 쇼호스트의 외형, 자세, 촬영 공간, 조명과 전체 분위기를 참고하는 이미지",
      },
    ],
    prompt: SHOW_HOST_SAMPLE_PROMPT,
    prompt_placeholder: "추가 요청이 있다면 입력해 주세요. 입력하지 않아도 제작할 수 있어요.\n예: 제품을 자연스럽게 가리키며 크기와 주요 특징이 잘 드러나도록 소개",
    video_style_cd: "SNS_SHORT",
    camera_angle_cd: "FRONT",
    camera_movement_cd: "STATIC",
    aspect_ratio: "9:16",
    duration_seconds: 8,
    resolution: "1080p",
  },
  {
    sort_no: 11,
    title: "AI 쇼호스트 - 남성 전신",
    src: SAMPLE_GIF_ROOT + "981eadb4-cb18-460d-993b-6ff03794aa11.mp4",
    alt: "AI 쇼호스트 큰 제품",
    scene_description: "쇼호스트가 비교적 큰 제품 옆에 서서 짧은 한국어 멘트로 소개하는 SNS 릴스 영상입니다.",
    user_reference_image: {
      required: true,
      min_count: 1,
      max_count: 1,
      image_guide: "준비물은 제품 이미지 1장이면 충분해요.",
      image_description: "쇼호스트가 소개할 비교적 큰 실제 판매 제품 이미지",
      add_label: "제품 이미지 추가",
      slot_label: "제품 정보",
      image_validation_message: "제품 이미지 1장을 추가해 주세요.",
      field_validation_message: "제품 종류, 제품명, 제품 특징을 모두 입력해 주세요.",
      input_fields: [
        { key: "product_type", label: "제품 종류", type: "text", required: true, placeholder: "예: 무선 이어폰", max_length: 999 },
        { key: "product_name", label: "제품명", type: "text", required: true, placeholder: "예: 클리어 버즈 프로", max_length: 999 },
        { key: "product_description", label: "제품 특징", type: "text", required: true, placeholder: "예: 노이즈 캔슬링과 선명한 통화를 지원", max_length: 999 },
      ],
      description_template: "제품 종류: {product_type} / 제품명 : {product_name} / 제품 특징 : {product_description}",
    },
    reference_images: [
      {
        image_url: "https://s3.ap-northeast-2.amazonaws.com/otdeal.file/genai/output/output_1787304628584_2371.png", // TODO: 서서 설명하는 쇼호스트 참조 이미지 S3 URL
        file_name: "서서 설명하는 쇼호스트 참조 이미지",
        description: "비교적 큰 제품을 옆에 두고 서서 소개하는 AI 쇼호스트의 외형, 자세, 촬영 공간, 조명과 전체 분위기를 참고하는 이미지",
      },
    ],
    prompt: SHOW_HOST_SAMPLE_PROMPT,
    prompt_placeholder: "추가 요청이 있다면 입력해 주세요. 입력하지 않아도 제작할 수 있어요.\n예: 제품 옆에서 가볍게 손짓하며 가장 눈에 띄는 특징을 중심으로 소개",
    video_style_cd: "SNS_SHORT",
    camera_angle_cd: "FRONT",
    camera_movement_cd: "STATIC",
    aspect_ratio: "9:16",
    duration_seconds: 8,
    resolution: "1080p",
  },
  {
    sort_no: 12,
    title: "재료로 요리 만들기",
    src: "https://s3.ap-northeast-2.amazonaws.com/otdeal.file/robo_instagram/veo/2026/08/24/d040cea6-dbc8-4cc0-b136-c8322b831a70.mp4",
    alt: "재료로 요리 만들기",
    scene_description: "입력한 재료에 어울리는 요리를 자동으로 구성해 완성하는 현실적인 SNS 요리 영상입니다.",
    user_reference_image: {
      required: true,
      min_count: 1,
      max_count: 1,
      image_guide: "준비물은 메인 재료 이미지 1장이면 충분해요.",
      image_description: "요리에 사용할 메인 재료 이미지",
      add_label: "재료 이미지 추가",
      slot_label: "재료명",
      image_validation_message: "메인 재료 이미지 1장을 추가해 주세요.",
      field_validation_message: "재료명을 입력해 주세요.",
      input_fields: [
        { key: "ingredient_name", label: "재료명", type: "text", required: true, placeholder: "예: 토마토", max_length: 999 },
      ],
      description_template: "{ingredient_name}",
    },
    reference_images: [
      {
        image_url: "https://s3.ap-northeast-2.amazonaws.com/otdeal.file/genai/output/output_1787310093352_442.png", // TODO: 요리 스튜디오 참조 이미지 S3 URL
        file_name: "요리 스튜디오 참조 이미지",
        description: "요리 장면의 촬영 공간, 조리대, 조명과 전체적인 푸드 숏폼 분위기를 참고하는 이미지",
      },
    ],
    prompt: COOKING_SAMPLE_PROMPT,
    prompt_placeholder: "추가 요청이 있다면 입력해 주세요. 입력하지 않아도 제작할 수 있어요.\n예: 재료의 신선한 단면과 조리되는 모습을 강조하고 완성된 요리를 마지막에 먹음직스럽게 보여주세요",
    video_style_cd: "SNS_SHORT",
    camera_angle_cd: "CLOSE_UP",
    camera_movement_cd: "STATIC",
    aspect_ratio: "9:16",
    duration_seconds: 8,
    resolution: "1080p",
  },
];

class InstagramAiVideoStudioStarter extends Component {
  constructor(props) {
    super(props);
    this.galleryLoading = false;
    this.pendingReset = false;
    this.scrollTimer = null;

    this.state = {
      galleryList: [],
      totalCnt: 0,
      galleryListLoading: false,
      hasMoreGalleryList: true,
      show_video_popup: false,

      initial_prompt: "",
      initial_sample_prompt: "",
      initial_sample_prompt_placeholder: "",
      initial_sample_mode: false,
      initial_sample_title: "",
      initial_sample_scene_description: "",
      initial_sample_image_guide: "",
      initial_sample_user_reference_description: "",
      initial_sample_user_reference_image: null,
      initial_reference_images: [],
      initial_image_url: "",
      initial_source_image_url: "",
      initial_history_seq: "",
      initial_result_seq: "",
      initial_result_no: "",
      initial_result_video_url: "",
      initial_video_style_cd: "",
      initial_camera_angle_cd: "",
      initial_camera_movement_cd: "",
      initial_aspect_ratio: "",
      initial_duration_seconds: 8,
      initial_resolution: "720p",

      deleteDialogOpen: false,
      deleteTarget: null,
      deleteProcessing: false,
      hiddenResultSeqs: new Set(),
      visibleRecommendCount: RECOMMEND_VISIBLE_COUNT_STEP,
      recommendExpanded: false,
      galleryExpanded: false,

      save_dialog_show_state: false,
      save_dialog_content: "로딩중 입니다.",
      save_dialog_button_list: [{ title: "확인", type: "1", display_yn: "N" }],
    };
  }

  componentDidMount() {
    const searchParams = new URLSearchParams(window.location.search);
    const openAiVideoStudioForTutorial = searchParams.get("open_ai_video_studio") === "Y";

    if (openAiVideoStudioForTutorial) {
      // 일반적인 "새 동영상 만들기"와 동일한 흐름을 사용합니다.
      // 이용기간이 종료된 경우에는 기존 checkInstagramFreePeriod() 정책대로 팝업이 열리지 않습니다.
      this.handleCreateVideo();

      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.delete("open_ai_video_studio");
      window.history.replaceState({}, document.title, `${currentUrl.pathname}${currentUrl.search}${currentUrl.hash}`);
    }

    if (this.getGalleryListUrl()) {
      this.loadGalleryList(true);
      window.addEventListener("scroll", this.handleWindowScroll);
    }
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleWindowScroll);
    if (this.scrollTimer) {
      clearTimeout(this.scrollTimer);
      this.scrollTimer = null;
    }
  }

  getGalleryListUrl = () => this.props.galleryListUrl || AI_VIDEO_STUDIO_GALLERY_LIST_URL;

  getRecommendVideoList = () => this.props.recommendVideos || RECOMMEND_VIDEO_LIST;

  getVisibleRecommendList = () => this.getRecommendVideoList().slice(0, this.state.visibleRecommendCount);

  handleLoadMoreRecommend = () => {
    this.setState((prevState) => ({
      visibleRecommendCount: prevState.visibleRecommendCount + RECOMMEND_VISIBLE_COUNT_STEP,
    }));
  };

  handleWindowScroll = () => {
    if (this.scrollTimer) clearTimeout(this.scrollTimer);
    this.scrollTimer = setTimeout(this.checkNeedLoadMore, 120);
  };

  checkNeedLoadMore = () => {
    if ((this.props.embedded && (!this.props.active || !this.state.galleryExpanded)) || !this.getGalleryListUrl() || this.galleryLoading || !this.state.hasMoreGalleryList) {
      return;
    }

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
    const documentHeight = Math.max(
      document.body.scrollHeight,
      document.documentElement.scrollHeight,
      document.body.offsetHeight,
      document.documentElement.offsetHeight,
      document.body.clientHeight,
      document.documentElement.clientHeight
    );

    if (scrollTop + viewportHeight >= documentHeight - viewportHeight * 1.5) {
      this.loadGalleryList(false);
    }
  };

  mergeList = (prevList, nextList) => {
    const merged = [];
    const seen = {};

    (prevList || []).concat(nextList || []).forEach((item, index) => {
      const key = this.getGalleryItemKey(item, index);
      if (seen[key]) return;
      seen[key] = true;
      merged.push(item);
    });

    return merged;
  };

  getGalleryItemKey = (item, index) => {
    if (!item) return `empty_${index}`;
    return String(
      item.ai_video_studio_result_seq ||
      item.result_seq ||
      item.seq ||
      item.generated_video_url ||
      item.preview_image_url ||
      index
    );
  };

  getListFromResponseData = (data) => {
    if (!data) return [];
    if (Array.isArray(data.list)) return data.list;
    if (Array.isArray(data.rows)) return data.rows;
    if (Array.isArray(data.data)) return data.data;
    return [];
  };

  getTotalCntFromResponseData = (data, listLength) => {
    if (!data) return 0;
    const totalCnt = data.totalCnt || data.total_cnt || data.total_count || data.count || 0;
    const parsed = Number(totalCnt);
    if (!isNaN(parsed) && parsed > 0) return parsed;
    return listLength || 0;
  };

  loadGalleryList = (reset) => {
    const galleryListUrl = this.getGalleryListUrl();
    if (!galleryListUrl) return;

    if (this.galleryLoading) {
      if (reset) this.pendingReset = true;
      return;
    }

    if (!reset && !this.state.hasMoreGalleryList) return;

    const rowcnt = this.props.galleryRowCnt || AI_VIDEO_STUDIO_HISTORY_PAGE_SIZE;
    const startidx = reset ? 0 : this.state.galleryList.length;

    this.galleryLoading = true;
    this.setState({ galleryListLoading: true });

    http.get(galleryListUrl, {
      params: {
        startidx,
        rowcnt,
        start: startidx,
        row_cnt: rowcnt,
        auto_yn: this.props.auto_yn || "",
      },
    })
      .then((res) => {
        const data = res && res.data ? res.data : {};
        const list = this.getListFromResponseData(data);
        const nextGalleryList = reset ? list : this.mergeList(this.state.galleryList, list);
        const totalCnt = this.getTotalCntFromResponseData(data, nextGalleryList.length);
        const addedCnt = reset ? nextGalleryList.length : nextGalleryList.length - this.state.galleryList.length;
        const hasExplicitTotalCnt = Number(data.totalCnt || data.total_cnt || data.total_count || data.count || 0) > 0;
        const hasMoreGalleryList = list.length > 0 && addedCnt > 0 && (
          hasExplicitTotalCnt ? nextGalleryList.length < totalCnt : list.length >= rowcnt
        );

        this.galleryLoading = false;
        this.setState({
          galleryList: nextGalleryList,
          totalCnt: totalCnt || nextGalleryList.length,
          galleryListLoading: false,
          hasMoreGalleryList,
        }, () => {
          if (this.pendingReset) {
            this.pendingReset = false;
            this.loadGalleryList(true);
          }
        });
      })
      .catch((error) => {
        console.error("AI 동영상 스튜디오 갤러리 호출 실패:", error);
        this.galleryLoading = false;
        this.setState({
          galleryList: reset ? [] : this.state.galleryList,
          totalCnt: reset ? 0 : this.state.totalCnt,
          galleryListLoading: false,
          hasMoreGalleryList: false,
        }, () => {
          if (this.pendingReset) {
            this.pendingReset = false;
            this.loadGalleryList(true);
          }
        });
      });
  };

  handleRefreshStudioVideoList = () => {
    this.loadGalleryList(true);
  };

  resetPopupState = () => {
    this.setState({
      show_video_popup: false,
      initial_prompt: "",
      initial_sample_prompt: "",
      initial_sample_prompt_placeholder: "",
      initial_sample_mode: false,
      initial_sample_title: "",
      initial_sample_scene_description: "",
      initial_sample_image_guide: "",
      initial_sample_user_reference_description: "",
      initial_sample_user_reference_image: null,
      initial_reference_images: [],
      initial_image_url: "",
      initial_source_image_url: "",
      initial_history_seq: "",
      initial_result_seq: "",
      initial_result_no: "",
      initial_result_video_url: "",
      initial_video_style_cd: "",
      initial_camera_angle_cd: "",
      initial_camera_movement_cd: "",
      initial_aspect_ratio: "",
      initial_duration_seconds: 8,
      initial_resolution: "720p",
    }, this.handleRefreshStudioVideoList);
  };

  checkInstagramFreePeriod = async () => {
    try {
      const res = await http.get("/rest/shop/instagram/FreePreriod");
      const isFinish = res && res.data ? Number(res.data.is_finish) : null;

      if (isFinish === 1) {
        window.alert("이용 기간이 종료되었습니다.");
        return false;
      }

      return true;
    } catch (error) {
      console.error("인스타그램 이용 기간 확인 실패:", error);
      return true;
    }
  };

  handleCreateVideo = async (e) => {
    if (e) e.stopPropagation();

    if (!(await this.checkInstagramFreePeriod())) return;

    this.setState({
      show_video_popup: true,
      initial_prompt: "",
      initial_sample_prompt: "",
      initial_sample_prompt_placeholder: "",
      initial_sample_mode: false,
      initial_sample_title: "",
      initial_sample_scene_description: "",
      initial_sample_image_guide: "",
      initial_sample_user_reference_description: "",
      initial_sample_user_reference_image: null,
      initial_reference_images: [],
      initial_image_url: "",
      initial_source_image_url: "",
      initial_history_seq: "",
      initial_result_seq: "",
      initial_result_no: "",
      initial_result_video_url: "",
      initial_video_style_cd: "",
      initial_camera_angle_cd: "",
      initial_camera_movement_cd: "",
      initial_aspect_ratio: this.props.aspect_ratio || "9:16",
      initial_duration_seconds: 8,
      initial_resolution: "720p",
    });
  };

  handleUseRecommendVideo = async (item, e) => {
    if (e) e.stopPropagation();

    if (!(await this.checkInstagramFreePeriod())) return;

    this.setState({
      show_video_popup: true,
      initial_prompt: "",
      initial_sample_prompt: item.prompt || "",
      initial_sample_prompt_placeholder: item.prompt_placeholder || "",
      initial_sample_mode: true,
      initial_sample_title: item.title || "",
      initial_sample_scene_description: item.scene_description || "",
      initial_sample_image_guide: (item.user_reference_image && item.user_reference_image.image_guide) || item.image_guide || "",
      initial_sample_user_reference_description: (item.user_reference_image && item.user_reference_image.image_description) || item.user_reference_description || "",
      initial_sample_user_reference_image: item.user_reference_image || null,
      initial_reference_images: Array.isArray(item.reference_images) ? item.reference_images : [],
      initial_image_url: item.input_src || "",
      initial_source_image_url: "",
      initial_history_seq: "",
      initial_result_seq: "",
      initial_result_no: "",
      initial_result_video_url: "",
      initial_video_style_cd: item.video_style_cd || "",
      initial_camera_angle_cd: item.camera_angle_cd || "",
      initial_camera_movement_cd: item.camera_movement_cd || "",
      initial_aspect_ratio: item.aspect_ratio || "9:16",
      initial_duration_seconds: Number(item.duration_seconds || 8),
      initial_resolution: item.resolution || "720p",
    });
  };

  handleOpenStudioHistory = async (item, e) => {
    if (e) e.stopPropagation();

    if (!(await this.checkInstagramFreePeriod())) return;

    const historySeq = item.ai_video_studio_history_seq || item.aiVideoStudioHistorySeq || "";
    const resultSeq = item.ai_video_studio_result_seq || item.aiVideoStudioResultSeq || "";
    const resultNo = item.result_no || item.resultNo || "";

    if (!historySeq) {
      window.alert("AI 동영상 스튜디오 히스토리 정보를 찾을 수 없습니다.");
      return;
    }

    this.setState({
      show_video_popup: true,
      initial_prompt: item.prompt_text || item.prompt || "",
      // 히스토리 진입에서는 Starter 원본 정보를 props로 넘기지 않습니다.
      // 어떤 샘플 기반이었는지는 historyDetail의 DB snapshot만으로 복원합니다.
      initial_sample_prompt: "",
      initial_sample_prompt_placeholder: "",
      initial_sample_mode: false,
      initial_sample_title: "",
      initial_sample_scene_description: "",
      initial_sample_image_guide: "",
      initial_sample_user_reference_description: "",
      initial_sample_user_reference_image: null,
      initial_reference_images: [],
      initial_image_url: "",
      initial_source_image_url: item.source_image_url || item.sourceImageUrl || "",
      initial_history_seq: historySeq,
      initial_result_seq: resultSeq,
      initial_result_no: resultNo,
      initial_result_video_url: this.getVideoUrl(item),
      initial_video_style_cd: item.video_style_cd || item.videoStyleCd || "",
      initial_camera_angle_cd: item.camera_angle_cd || item.cameraAngleCd || "",
      initial_camera_movement_cd: item.camera_movement_cd || item.cameraMovementCd || "",
      initial_aspect_ratio: item.aspect_ratio || item.aspectRatio || "9:16",
      initial_duration_seconds: Number(item.duration_seconds || 8),
      initial_resolution: item.resolution || "720p",
    });
  };

  getResultSeq = (item) => {
    if (!item) return "";
    return item.ai_video_studio_result_seq || item.aiVideoStudioResultSeq || item.result_seq || item.seq || "";
  };

  handleDeleteStudioVideo = (item, e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    const resultSeq = this.getResultSeq(item);
    if (!resultSeq) {
      window.alert("삭제할 AI 동영상 정보를 찾을 수 없습니다.");
      return;
    }

    this.setState({
      deleteDialogOpen: true,
      deleteTarget: item,
      deleteProcessing: false,
    });
  };

  closeDeleteDialog = () => {
    if (this.state.deleteProcessing) return;
    this.setState({
      deleteDialogOpen: false,
      deleteTarget: null,
      deleteProcessing: false,
    });
  };

  confirmDeleteStudioVideo = async () => {
    const { deleteTarget, deleteProcessing } = this.state;
    if (!deleteTarget || deleteProcessing) return;

    const resultSeq = this.getResultSeq(deleteTarget);
    if (!resultSeq) {
      window.alert("삭제할 AI 동영상 정보를 찾을 수 없습니다.");
      return;
    }

    this.setState({
      deleteProcessing: true,
      save_dialog_show_state: true,
      save_dialog_content: "삭제 중 입니다...",
      save_dialog_button_list: [{ title: "확인", type: "1", display_yn: "N" }],
    });

    try {
      const response = await http.post(
        AI_VIDEO_STUDIO_GALLERY_HIDE_URL,
        { ai_video_studio_result_seq: resultSeq },
        { headers: { "Content-Type": "application/json" } }
      );
      const data = response && response.data ? response.data : {};

      if ((data.status && data.status !== "success") || (data.result && data.result !== "success")) {
        throw new Error(data.message || "AI 동영상 삭제에 실패했습니다.");
      }

      this.setState((prevState) => {
        const hiddenResultSeqs = new Set(prevState.hiddenResultSeqs || []);
        hiddenResultSeqs.add(String(resultSeq));

        return {
          galleryList: (prevState.galleryList || []).filter(
            (item) => String(this.getResultSeq(item)) !== String(resultSeq)
          ),
          totalCnt: Math.max((prevState.totalCnt || 0) - 1, 0),
          hiddenResultSeqs,
          deleteDialogOpen: false,
          deleteTarget: null,
          deleteProcessing: false,
          save_dialog_show_state: true,
          save_dialog_content: "삭제 완료되었습니다.",
          save_dialog_button_list: [
            {
              title: "확인",
              type: "1",
              display_yn: "Y",
              event_method: () => this.setState({ save_dialog_show_state: false }),
            },
          ],
        };
      }, () => {
        this.handleRefreshStudioVideoList();
        setTimeout(this.checkNeedLoadMore, 100);
      });
    } catch (error) {
      console.error("AI 동영상 갤러리 삭제 실패:", error);
      const message = error?.response?.data?.message || error?.message || "AI 동영상 삭제에 실패했습니다.";
      this.setState({ deleteProcessing: false, save_dialog_show_state: false }, () => window.alert(message));
    }
  };

  moveToCreatePostWithVideo = (result) => {
    const videoUrl = result?.appliedVideo || result?.appliedValue || result?.generated_video_url || result?.video_url || "";
    if (!videoUrl || typeof videoUrl !== "string") {
      window.alert("등록할 동영상이 없습니다.");
      return;
    }

    const aspectRatio = String(result?.aspect_ratio || result?.ratio || "9:16").replace("/", ":");

    sessionStorage.setItem(AI_VIDEO_STUDIO_APPLY_VIDEO_STORAGE_KEY, JSON.stringify({
      opened_from: "AI_VIDEO_STUDIO_LIST",
      video_url: videoUrl,
      appliedVideo: videoUrl,
      source_url: videoUrl,
      aspect_ratio: aspectRatio,
      ratio: aspectRatio.replace(":", "/"),
      ai_video_studio_history_seq: result?.ai_video_studio_history_seq || "",
      ai_video_studio_result_seq: result?.ai_video_studio_result_seq || "",
      result_no: result?.result_no || "",
    }));

    window.location.href = INSTAGRAM_CREATE_POST_URL + "?apply_ai_video_studio_video=Y";
  };

  handleInstagramRegister = (item, e) => {
    if (e) e.stopPropagation();

    const videoUrl = this.getVideoUrl(item);
    if (!videoUrl) {
      window.alert("등록할 동영상이 없습니다.");
      return;
    }

    this.moveToCreatePostWithVideo({
      generated_video_url: videoUrl,
      aspect_ratio: item.aspect_ratio || item.aspectRatio || "9:16",
      ai_video_studio_history_seq: item.ai_video_studio_history_seq || "",
      ai_video_studio_result_seq: this.getResultSeq(item),
      result_no: item.result_no || "",
    });
  };

  getGalleryList = () => {
    let galleryList = this.state.galleryList || [];
    if (Array.isArray(this.props.galleryList) && this.props.galleryList.length > 0) {
      galleryList = this.props.galleryList;
    }

    const hiddenResultSeqs = this.state.hiddenResultSeqs || new Set();
    return galleryList.filter((item) => {
      const resultSeq = this.getResultSeq(item);
      return !resultSeq || !hiddenResultSeqs.has(String(resultSeq));
    });
  };

  getPreviewImageUrl = (item) => {
    return item.preview_image_url
      || item.previewImageUrl
      || item.generated_thumbnail_url
      || item.generatedThumbnailUrl
      || item.source_image_url
      || item.sourceImageUrl
      || item.thumbnail_url
      || item.src
      || "";
  };

  // 마이 스튜디오 갤러리에서는 시작 이미지를 썸네일로 사용하지 않는다.
  // 백엔드에서 생성 영상 썸네일을 제공하면 우선 사용하고,
  // 썸네일이 없으면 아래 renderGalleryCard에서 영상 첫 프레임을 직접 표시한다.
  getGeneratedVideoThumbnailUrl = (item) => {
    return item.generated_thumbnail_url
      || item.generatedThumbnailUrl
      || item.thumbnail_url
      || item.thumbnailUrl
      || "";
  };

  handleVideoThumbnailLoadedMetadata = (e) => {
    const video = e && e.currentTarget;
    if (!video) return;

    try {
      const duration = Number(video.duration);
      if (!isFinite(duration) || duration <= 0) return;

      // 0초 프레임이 검게 표시되는 브라우저를 고려해 아주 조금 뒤의 프레임을 사용한다.
      const thumbnailTime = Math.min(0.1, Math.max(duration - 0.01, 0));
      if (thumbnailTime > 0 && Math.abs(Number(video.currentTime || 0) - thumbnailTime) > 0.01) {
        video.currentTime = thumbnailTime;
      }
    } catch (error) {
      console.warn("AI 동영상 썸네일 프레임 설정 실패:", error);
    }
  };

  getVideoUrl = (item) => {
    return item.generated_video_url
      || item.generatedVideoUrl
      || item.video_url
      || item.videoUrl
      || item.file_url
      || "";
  };

  getDownloadFileName = (item, videoUrl) => {
    const seq = this.getResultSeq(item);
    const urlWithoutQuery = String(videoUrl || "").split("?")[0];
    const extMatch = urlWithoutQuery.match(/\.([a-zA-Z0-9]+)$/);
    const ext = extMatch ? extMatch[1] : "mp4";
    return `robomd_ai_video_studio${seq ? `_${seq}` : ""}.${ext}`;
  };

  handleDownloadVideo = async (item, e) => {
    if (e) e.stopPropagation();

    const videoUrl = this.getVideoUrl(item);
    if (!videoUrl) {
      window.alert("다운로드할 영상이 없습니다.");
      return;
    }

    try {
      const cacheBuster = videoUrl.includes("?") ? `&t=${new Date().getTime()}` : `?t=${new Date().getTime()}`;
      const response = await fetch(videoUrl + cacheBuster);
      if (!response.ok) throw new Error("영상 다운로드 요청 실패");

      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = this.getDownloadFileName(item, videoUrl);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("AI 동영상 다운로드 실패:", error);
      const link = document.createElement("a");
      link.href = videoUrl;
      link.download = this.getDownloadFileName(item, videoUrl);
      link.target = "_blank";
      link.rel = "noopener noreferrer";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  formatDateText = (dateString) => {
    if (!dateString) return "";

    const normalized = String(dateString).replace(/([+-]\d{2})(\d{2})$/, "$1:$2");
    const date = new Date(normalized);
    if (isNaN(date.getTime())) {
      return String(dateString).substring(0, 10).replace(/-/g, ".");
    }

    const now = new Date();
    const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const dateStart = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    const diffMs = now.getTime() - date.getTime();
    const diffMinutes = Math.floor(diffMs / (1000 * 60));
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffDays = Math.floor((todayStart.getTime() - dateStart.getTime()) / (1000 * 60 * 60 * 24));

    if (diffDays === 0) {
      if (diffMinutes < 1) return "방금 전";
      return diffHours >= 1 ? `${diffHours}시간 전` : `${diffMinutes}분 전`;
    }

    if (diffDays === 1) return "어제";

    return `${date.getFullYear()}.${String(date.getMonth() + 1).padStart(2, "0")}.${String(date.getDate()).padStart(2, "0")}`;
  };

  renderPlusIcon(size) {
    return (
      <img
        src="https://robomd.io/static/media/default_plus.466aee97.svg"
        className="plus-icon"
        style={{ width: size || 16 }}
        alt="+"
      />
    );
  }

  renderRecommendCard = (item, index) => {
    const previewUrl = this.getPreviewImageUrl(item);
    const isVideoPreview = /\.mp4(?:$|[?#])/i.test(String(previewUrl || ""));

    return (
      <div
        className="video-card recommend-card"
        key={item.sort_no || previewUrl || index}
        role="button"
        tabIndex={0}
        onClick={(e) => this.handleUseRecommendVideo(item, e)}
      >
        <div className="card-badge mint-bg">{item.title || "추천 영상"}</div>
        {isVideoPreview ? (
          <video
            className="preview-img recommend-video-preview"
            src={previewUrl}
            autoPlay
            muted
            loop
            playsInline
            preload="metadata"
            disablePictureInPicture
            aria-label={item.alt || item.title || "추천 AI 영상"}
            onCanPlay={(e) => {
              e.currentTarget.classList.add("loaded");
            }}
            onTimeUpdate={(e) => {
              const video = e.currentTarget;

              // 마지막 약 0.5초는 보여주지 않고 처음으로 이동
              if (
                video.duration &&
                video.currentTime >= video.duration - 0.5
              ) {
                video.currentTime = 0;
                video.play().catch(() => {});
              }
            }}
          />
        ) : (
          <img
            className="preview-img"
            src={previewUrl}
            alt={item.alt || item.title || "추천 AI 영상"}
            loading="lazy"
            decoding="async"
          />
        )}
        <div className="play-chip"><i className="fa fa-play" style={{ marginRight: "3px" }}></i> 추천 영상</div>
        <div className="hover-overlay">
          <button className="btn-overlay btn-overlay-mint" type="button" onClick={(e) => this.handleUseRecommendVideo(item, e)}>
            이 설정으로 시작
          </button>
        </div>
      </div>
    );
  };

  renderGalleryCard = (item, index) => {
    const videoUrl = this.getVideoUrl(item);
    const generatedThumbnailUrl = this.getGeneratedVideoThumbnailUrl(item);
    const badgeText = this.formatDateText(item.reg_date);
    const title = item.history_title || item.prompt_text || "AI 동영상";

    return (
      <div
        className="video-card"
        key={this.getGalleryItemKey(item, index)}
        role="button"
        tabIndex={0}
        onClick={(e) => this.handleOpenStudioHistory(item, e)}
      >
        {badgeText ? <div className="card-badge">{badgeText}</div> : null}
        <button
          className="card-delete-button"
          type="button"
          title="마이 스튜디오 갤러리에서 삭제"
          aria-label="마이 스튜디오 갤러리에서 삭제"
          onClick={(e) => this.handleDeleteStudioVideo(item, e)}
        >
          <i className="fa fa-trash-can"></i>
        </button>
        {videoUrl ? (
          <video
            className="preview-img gallery-video-thumbnail"
            src={videoUrl}
            poster={generatedThumbnailUrl || undefined}
            preload="metadata"
            muted
            playsInline
            aria-label={title}
            onLoadedMetadata={this.handleVideoThumbnailLoadedMetadata}
          />
        ) : generatedThumbnailUrl ? (
          <img className="preview-img" src={generatedThumbnailUrl} alt={title} />
        ) : (
          <div className="preview-img gallery-thumbnail-empty" aria-label={title}></div>
        )}
        <div className="video-dim"></div>
        <div className="play-circle"><i className="fa fa-play"></i></div>
        <div className="card-footer">
          <div className="card-title">{title}</div>
          <div className="card-meta">
            <span>{item.aspect_ratio || "9:16"}</span>
            <span>·</span>
            <span>{item.duration_seconds || 8}초</span>
          </div>
        </div>
        <div className="hover-overlay">
          <button className="btn-overlay btn-overlay-navy" type="button" onClick={(e) => this.handleOpenStudioHistory(item, e)}>
            <i className="fa fa-arrow-up-right-from-square"></i> 작업 열기
          </button>
          <button className="btn-overlay btn-overlay-mint" type="button" onClick={(e) => this.handleInstagramRegister(item, e)}>
            <i className="fa fa-brands fa-instagram"></i> 인스타 등록
          </button>
          <button className="btn-overlay btn-overlay-outline" type="button" onClick={(e) => this.handleDownloadVideo(item, e)}>
            <i className="fa fa-download"></i> 다운로드
          </button>
        </div>
      </div>
    );
  };

  renderEmptyState = () => (
    <div className="empty-state-wrapper">
      <img
        src="https://robomd.io/static/media/robo_img_icon.abed362a.svg"
        alt="빈 갤러리 아이콘"
        className="empty-state-icon"
      />
      <h4 className="empty-state-title">아직 생성된 AI 동영상이 없습니다.</h4>
      <p className="empty-state-desc">상단의 샘플을 선택하거나 새 동영상을 만들어 첫 번째 결과를 생성해보세요.</p>
      <button className="common_button hover_mint empty-create-button" type="button" onClick={this.handleCreateVideo}>
        {this.renderPlusIcon(14)} 새 동영상 만들기
      </button>
    </div>
  );

  renderLoadingState = () => (
    <div className="empty-state-wrapper loading-state-wrapper">
      <img
        src="https://robomd.io/static/media/robo_img_icon.abed362a.svg"
        alt="AI 동영상 목록 로딩 아이콘"
        className="empty-state-icon"
      />
      <h4 className="empty-state-title">AI 동영상 목록을 불러오는 중입니다.</h4>
      <p className="empty-state-desc">잠시만 기다려주세요.</p>
    </div>
  );

  renderLoadMoreState = () => (
    <div className="load-more-state">
      <span className="load-more-spinner"></span>
      <span>AI 동영상을 더 불러오는 중입니다.</span>
    </div>
  );

  renderVideoStudioPopup = () => {
    if (!this.state.show_video_popup) return null;

    return (
      <AiVideoStudioWorkflowClass
        view_mode="popup"
        ai_response_type="VIDEO"
        opened_from="AI_VIDEO_STUDIO_LIST"
        initial_prompt={this.state.initial_prompt || ""}
        initial_sample_prompt={this.state.initial_sample_prompt || ""}
        initial_sample_prompt_placeholder={this.state.initial_sample_prompt_placeholder || ""}
        initial_sample_mode={this.state.initial_sample_mode === true}
        initial_sample_title={this.state.initial_sample_title || ""}
        initial_sample_scene_description={this.state.initial_sample_scene_description || ""}
        initial_sample_image_guide={this.state.initial_sample_image_guide || ""}
        initial_sample_user_reference_description={this.state.initial_sample_user_reference_description || ""}
        initial_sample_user_reference_image={this.state.initial_sample_user_reference_image || null}
        initial_reference_images={this.state.initial_reference_images || []}
        initial_image_url={this.state.initial_image_url || ""}
        initial_source_image_url={this.state.initial_source_image_url || ""}
        initial_history_seq={this.state.initial_history_seq || ""}
        initial_result_seq={this.state.initial_result_seq || ""}
        initial_result_no={this.state.initial_result_no || ""}
        initial_result_video_url={this.state.initial_result_video_url || ""}
        initial_video_style_cd={this.state.initial_video_style_cd || ""}
        initial_camera_angle_cd={this.state.initial_camera_angle_cd || ""}
        initial_camera_movement_cd={this.state.initial_camera_movement_cd || ""}
        initial_aspect_ratio={this.state.initial_aspect_ratio || (this.props.aspect_ratio || "9:16")}
        initial_duration_seconds={this.state.initial_duration_seconds || 8}
        initial_resolution={this.state.initial_resolution || "720p"}
        onClose={this.resetPopupState}
        onRefreshStudioVideoList={this.handleRefreshStudioVideoList}
        onApplyRule={(result) => {
          this.resetPopupState();

          if (typeof this.props.onApplyVideo === "function") {
            this.props.onApplyVideo(result);
            return;
          }

          if (result && result.ai_response_type === "VIDEO") {
            this.moveToCreatePostWithVideo(result);
          }
        }}
      />
    );
  };

  toggleUnifiedSection(section) {
    const key = section === "recommend" ? "recommendExpanded" : "galleryExpanded";
    const willExpand = !this.state[key];
    this.setState({ [key]: willExpand }, () => {
      if (willExpand && section === "gallery") {
        if (typeof this.checkNeedLoadMore === "function") {
          this.checkNeedLoadMore();
        }
      } else if (!willExpand) {
        const target = section === "recommend" ? this.recommendSectionEl : this.gallerySectionEl;
        if (target && typeof target.scrollIntoView === "function") {
          target.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }
    });
  }

  renderStyle() {
    return `
      ${this.props.embedded ? "" : `#page-wrapper {
        padding: 72px 0 0 220px;
        max-width: 100%;
      }`}

      .ai-video-studio-starter {
        --primary-mint: #00e2e6;
        --primary-dark: #00bfc2;
        --navy-dark: #0A1A2F;
        --bg-body: #f4f7f9;
        --bg-canvas: #ffffff;
        --text-primary: #111827;
        --text-secondary: #4b5563;
        --text-muted: #9ca3af;
        --border-color: #e5e7eb;
        background-color: var(--bg-body);
        color: var(--text-primary);
        min-height: 100vh;
        width: 100%;
        overflow-x: hidden;
        font-family: 'Noto Sans KR', sans-serif;
        letter-spacing: -0.3px;
      }

      .ai-video-studio-starter *,
      .ai-video-studio-starter *::before,
      .ai-video-studio-starter *::after {
        box-sizing: border-box;
      }

      .ai-video-studio-starter button {
        font-family: inherit;
      }

      .ai-video-studio-starter .fa {
        font-family: "Font Awesome 6 Free" !important;
        font-style: normal;
        font-weight: 900;
      }

      .ai-video-studio-starter .fa-brands {
        font-family: "Font Awesome 6 Brands" !important;
        font-weight: 400;
      }

      .ai-video-studio-starter .main-content {
        display: flex;
        flex-direction: column;
        min-width: 0;
        width: 100%;
      }

      .ai-video-studio-starter .top-header {
        height: 60px;
        background-color: var(--bg-canvas);
        border-bottom: 1px solid var(--border-color);
        display: flex;
        align-items: center;
        padding: 0 32px;
        font-size: 14px;
        font-weight: 600;
        color: var(--text-primary);
      }

      .ai-video-studio-starter .top-header span {
        color: var(--text-muted);
        font-weight: 400;
        margin-right: 8px;
      }

      .ai-video-studio-starter .content-inner {
        padding: 48px 40px;
        max-width: 1600px;
        width: 100%;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        gap: 48px;
      }

      .ai-video-studio-starter .center-hero {
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 16px;
        margin-bottom: 8px;
      }

      .ai-video-studio-starter .center-hero h2 {
        font-size: 28px;
        font-weight: 700;
        color: var(--navy-dark);
        margin: 0;
      }

      .ai-video-studio-starter .center-hero p {
        font-size: 15px;
        color: var(--text-secondary);
        margin: 0 0 16px 0;
      }

      .ai-video-studio-starter .common_button.hover_mint,
      .ai-video-studio-starter .btn-mint {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        border: none;
        background: var(--primary-mint);
        color: var(--navy-dark);
        cursor: pointer;
        padding: 14px 32px;
        font-size: 15px;
        line-height: 1;
        border-radius: 8px !important;
        font-weight: 700 !important;
        box-shadow: 0 4px 12px rgba(0, 226, 230, 0.2);
        transition: all 0.2s !important;
      }

      .ai-video-studio-starter .common_button.hover_mint:hover,
      .ai-video-studio-starter .btn-mint:hover {
        background: #00D3E0 !important;
        transform: translateY(-2px) !important;
      }

      .ai-video-studio-starter .common_button.hover_mint::after {
        width: 0 !important;
        height: 0 !important;
      }

      .ai-video-studio-starter .plus-icon {
        filter: brightness(0);
        flex-shrink: 0;
      }

      .ai-video-studio-starter .section-header {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        margin-bottom: 16px;
        padding-bottom: 12px;
        border-bottom: 2px solid var(--border-color);
      }

      .ai-video-studio-starter .gallery-section .section-header.empty-header {
        margin-bottom: 0;
      }

      .ai-video-studio-starter .section-title h3 {
        font-size: 18px;
        font-weight: 700;
        color: var(--navy-dark);
        margin: 0;
      }

      .ai-video-studio-starter .section-subtitle {
        margin-top: 6px;
        font-size: 13px;
        color: var(--text-secondary);
      }

      .ai-video-studio-starter .section-count {
        font-size: 14px;
        font-weight: 600;
        color: var(--text-secondary);
      }

      .ai-video-studio-starter .section-count span {
        color: var(--primary-dark);
      }

      .ai-video-studio-starter .video-grid {
        display: grid;
        grid-template-columns: repeat(6, minmax(0, 1fr));
        gap: 20px;
        width: 100%;
      }

      .ai-video-studio-starter .video-card {
        position: relative;
        border-radius: 14px;
        overflow: hidden;
        background: var(--bg-canvas);
        border: 1px solid var(--border-color);
        box-shadow: 0 2px 8px rgba(10, 26, 47, 0.04);
        aspect-ratio: 9 / 16;
        cursor: pointer;
        transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;
      }

      .ai-video-studio-starter .preview-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
        transition: transform 0.35s ease;
      }

      .ai-video-studio-starter .recommend-video-preview,
      .ai-video-studio-starter .gallery-video-thumbnail {
        pointer-events: none;
        background: var(--navy-dark);
      }

      .ai-video-studio-starter .gallery-thumbnail-empty {
        background: linear-gradient(145deg, #12243b, #081524);
      }

      .ai-video-studio-starter .video-card:hover {
        transform: translateY(-4px);
        box-shadow: 0 10px 18px rgba(10, 26, 47, 0.08);
        border-color: var(--primary-dark);
      }

      .ai-video-studio-starter .video-card:hover .preview-img {
        transform: scale(1.04);
      }

      .ai-video-studio-starter .video-card:hover .hover-overlay,
      .ai-video-studio-starter .video-card:hover .card-delete-button {
        opacity: 1;
      }

      .ai-video-studio-starter .card-badge {
        position: absolute;
        top: 10px;
        left: 10px;
        background: rgba(255, 255, 255, 0.95);
        color: var(--navy-dark);
        font-size: 11px;
        font-weight: 700;
        padding: 4px 10px;
        border-radius: 20px;
        z-index: 20;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
      }

      .ai-video-studio-starter .card-badge.mint-bg {
        background: rgba(10, 26, 47, 0.9);
        color: var(--primary-mint);
      }

      .ai-video-studio-starter .card-delete-button {
        position: absolute;
        top: 10px;
        right: 10px;
        width: 30px;
        height: 30px;
        border: none;
        border-radius: 999px;
        color: #ffffff;
        z-index: 25;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        opacity: 0;
        transition: all 0.2s ease;
        background: rgba(10, 26, 47, 0.45);
      }

      .ai-video-studio-starter .card-delete-button:hover {
        background: rgba(10, 26, 47, 0.7);
      }

      .ai-video-studio-starter .video-dim {
        position: absolute;
        inset: 0;
        background: linear-gradient(to top, rgba(10, 26, 47, 0.72), rgba(10, 26, 47, 0.08) 55%, rgba(10, 26, 47, 0.02));
        z-index: 4;
      }

      .ai-video-studio-starter .play-circle {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 58px;
        height: 58px;
        border-radius: 999px;
        background: rgba(255, 255, 255, 0.88);
        color: var(--navy-dark);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 6;
        font-size: 20px;
        box-shadow: 0 8px 16px rgba(10, 26, 47, 0.18);
      }

      .ai-video-studio-starter .play-chip {
        position: absolute;
        left: 12px;
        bottom: 12px;
        z-index: 6;
        color: #ffffff;
        background: rgba(10, 26, 47, 0.72);
        border-radius: 999px;
        padding: 6px 10px;
        font-size: 11px;
        font-weight: 700;
      }

      .ai-video-studio-starter .card-footer {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 7;
        padding: 14px 14px 12px;
        color: #ffffff;
      }

      .ai-video-studio-starter .card-title {
        font-size: 14px;
        font-weight: 700;
        line-height: 1.4;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }

      .ai-video-studio-starter .card-meta {
        margin-top: 6px;
        display: flex;
        align-items: center;
        gap: 6px;
        font-size: 12px;
        color: rgba(255, 255, 255, 0.86);
      }

      .ai-video-studio-starter .hover-overlay {
        position: absolute;
        inset: 0;
        background: rgba(10, 26, 47, 0.78);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 8px;
        opacity: 0;
        transition: opacity 0.2s ease;
        z-index: 15;
        padding: 12px;
      }

      .ai-video-studio-starter .btn-overlay {
        width: 100%;
        max-width: 160px;
        height: 38px;
        border-radius: 8px;
        border: 1px solid transparent;
        font-size: 13px;
        font-weight: 700;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
      }

      .ai-video-studio-starter .btn-overlay-navy {
        background: #ffffff;
        color: var(--navy-dark);
      }

      .ai-video-studio-starter .btn-overlay-mint {
        background: var(--primary-mint);
        color: var(--navy-dark);
      }

      .ai-video-studio-starter .btn-overlay-outline {
        background: transparent;
        color: #ffffff;
        border-color: rgba(255, 255, 255, 0.65);
      }

      .ai-video-studio-starter .empty-state-wrapper {
        min-height: 340px;
        background: #ffffff;
        border: 1px solid var(--border-color);
        border-radius: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
        padding: 48px 24px;
      }

      .ai-video-studio-starter .empty-state-icon {
        width: 64px;
        margin-bottom: 20px;
      }

      .ai-video-studio-starter .empty-state-title {
        font-size: 20px;
        font-weight: 700;
        color: var(--navy-dark);
        margin: 0 0 10px;
      }

      .ai-video-studio-starter .empty-state-desc {
        margin: 0 0 22px;
        color: var(--text-secondary);
        font-size: 14px;
        line-height: 1.6;
      }

      .ai-video-studio-starter .empty-create-button {
        min-width: 180px;
      }

      .ai-video-studio-starter .load-more-state {
        margin-top: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        color: var(--text-secondary);
        font-size: 14px;
      }

      .ai-video-studio-starter .load-more-spinner {
        width: 18px;
        height: 18px;
        border-radius: 50%;
        border: 2px solid rgba(0, 226, 230, 0.3);
        border-top-color: var(--primary-dark);
        animation: ai-video-spin 0.8s linear infinite;
      }

      .ai-video-studio-starter .recommend-load-more-wrap {
        margin-top: 24px;
        display: flex;
        justify-content: center;
      }

      .ai-video-studio-starter .recommend-load-more-button {
        padding: 4px 8px;
        border: 0;
        background: transparent;
        color: var(--text-secondary);
        font-size: 14px;
        font-weight: 600;
        line-height: 1.4;
        cursor: pointer;
        transition: color 0.2s ease;
        display: inline-flex;
        align-items: center;
        gap: 5px;
      }

      .ai-video-studio-starter .recommend-load-more-button:hover {
        color: var(--primary-mint);
      }

      @keyframes ai-video-spin {
        to { transform: rotate(360deg); }
      }

      @media (max-width: 1600px) {
        .ai-video-studio-starter .video-grid { grid-template-columns: repeat(5, minmax(0, 1fr)); }
      }

      @media (max-width: 1360px) {
        .ai-video-studio-starter .video-grid { grid-template-columns: repeat(4, minmax(0, 1fr)); }
      }

      @media (max-width: 1100px) {
        ${this.props.embedded ? "" : "#page-wrapper { padding-left: 0; }"}
        .ai-video-studio-starter .content-inner { padding: 32px 20px; }
        .ai-video-studio-starter .video-grid { grid-template-columns: repeat(3, minmax(0, 1fr)); }
      }

      @media (max-width: 768px) {
        .ai-video-studio-starter .top-header { padding: 0 16px; }
        .ai-video-studio-starter .section-header { flex-direction: column; align-items: flex-start; gap: 8px; }
        .ai-video-studio-starter .video-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 14px; }
      }

      @media (max-width: 480px) {
        .ai-video-studio-starter .video-grid { grid-template-columns: 1fr; }
      }

      .recommend-card {
        content-visibility: auto;
      }

      .ai-video-studio-starter .recommend-video-preview {
        opacity: 0;
        transition: opacity 0.2s ease;
      }

      .ai-video-studio-starter .recommend-video-preview.loaded {
        opacity: 1;
      }
    `;
  }

  render() {
    const recommendList = this.getRecommendVideoList();
    const collapsedCount = this.props.collapsedCount || RECOMMEND_VISIBLE_COUNT_STEP;
    const visibleRecommendList = this.props.embedded
      ? (this.state.recommendExpanded ? recommendList : recommendList.slice(0, collapsedCount))
      : this.getVisibleRecommendList();
    const hasMoreRecommendList = visibleRecommendList.length < recommendList.length;
    const galleryList = this.getGalleryList();
    const isGalleryLoading = this.state.galleryListLoading && this.state.galleryList.length === 0;
    const isGalleryMoreLoading = this.state.galleryListLoading && this.state.galleryList.length > 0;
    const hasGalleryList = galleryList.length > 0;
    const totalGalleryCount = this.state.totalCnt || galleryList.length;
    const displayedGalleryList = (this.props.embedded && !this.state.galleryExpanded) ? galleryList.slice(0, collapsedCount) : galleryList;

    const content = (
      <div className="instagram-product-automation-list ai-video-studio-starter">
          <style>{this.renderStyle()}</style>
          <main className="main-content">
          {/* 기존 페이지에서 사용하던 상단 경로는 주석 상태를 유지합니다. */}
          <div className="content-inner">
            {!this.props.embedded && (
              <section className="center-hero">
                <h2>AI 동영상 스튜디오</h2>
                <p>로보MD가 제공하는 용도별 추천 영상을 선택하거나, 직접 브랜드에 맞는 AI 영상을 손쉽게 만들어보세요.</p>
                <button className="common_button hover_mint" type="button" onClick={this.handleCreateVideo}>
                  {this.renderPlusIcon(14)} 새 동영상 만들기
                </button>
              </section>
            )}

            <section className="recommend-section" ref={(el) => { this.recommendSectionEl = el; }}>
              {this.props.embedded ? (
                <StudioSectionHeader title="AI 동영상 스타일 갤러리" totalCount={recommendList.length}
                  buttonText="모든 템플릿 보기" expanded={this.state.recommendExpanded} canToggle={recommendList.length > collapsedCount}
                  onToggle={() => this.toggleUnifiedSection("recommend")} />
              ) : (
                <div className="section-header"><div className="section-title"><h3>로보MD 용도별 추천 영상</h3></div></div>
              )}
              <div className="video-grid">
                {visibleRecommendList.map((item, index) => this.renderRecommendCard(item, index))}
              </div>
              {this.props.embedded ? (
                <StudioFoldControl expanded={this.state.recommendExpanded && recommendList.length > collapsedCount} label="접기" onToggle={() => this.toggleUnifiedSection("recommend")} />
              ) : hasMoreRecommendList ? (
                <div className="recommend-load-more-wrap">
                  <button className="recommend-load-more-button" type="button" onClick={this.handleLoadMoreRecommend}>
                    <span>더보기</span>
                    <i className="fa fa-angle-down fa-solid" aria-hidden="true" />
                  </button>
                </div>
              ) : null}
            </section>

            <section className="gallery-section" ref={(el) => { this.gallerySectionEl = el; }}>
              {this.props.embedded ? (
                <StudioSectionHeader title="마이 갤러리" totalCount={totalGalleryCount}
                  buttonText="모든 작업물 보기" expanded={this.state.galleryExpanded}
                  canToggle={galleryList.length > collapsedCount || totalGalleryCount > collapsedCount}
                  onToggle={() => this.toggleUnifiedSection("gallery")} />
              ) : (
                <div className={`section-header${hasGalleryList ? "" : " empty-header"}`}>
                  <div className="section-title"><h3>마이 스튜디오 갤러리</h3></div>
                  {hasGalleryList ? <div className="section-count">총 <span>{totalGalleryCount}</span>개의 동영상</div> : null}
                </div>
              )}

              {isGalleryLoading ? (
                this.renderLoadingState()
              ) : hasGalleryList ? (
                <>
                  <div className="video-grid">
                    {displayedGalleryList.map((item, index) => this.renderGalleryCard(item, index))}
                  </div>
                  {isGalleryMoreLoading && (!this.props.embedded || this.state.galleryExpanded) ? this.renderLoadMoreState() : null}
                    {this.props.embedded ? <StudioFoldControl expanded={this.state.galleryExpanded} label="작업물 접기" onToggle={() => this.toggleUnifiedSection("gallery")} /> : null}
                </>
              ) : (
                this.renderEmptyState()
              )}
            </section>
          </div>
        </main>

        {this.renderVideoStudioPopup()}

        {this.state.deleteDialogOpen && this.state.deleteTarget ? (
          <TitleContentDialogV2
            title="이 동영상을 삭제하시겠습니까?"
            content="삭제하면 마이 스튜디오 갤러리에서만 사라집니다.<br/>AI 동영상 스튜디오 작업 이력과 생성된 영상 데이터는 삭제되지 않습니다."
            popup_close={this.closeDeleteDialog}
            button_list={[
              {
                title: this.state.deleteProcessing ? "삭제 중..." : "삭제",
                event_method: this.confirmDeleteStudioVideo,
              },
              {
                title: "취소",
                event_method: this.closeDeleteDialog,
              },
            ]}
          />
        ) : null}

          {this.state.save_dialog_show_state ? (
            <SaveDialogV2
              content={this.state.save_dialog_content}
              button_list={this.state.save_dialog_button_list}
            />
          ) : null}
      </div>
    );

    // 기존 관리자 레이아웃은 독립 페이지에서만 사용합니다.
    // 통합 페이지(embedded=true)에는 page-wrapper DOM 자체를 생성하지 않습니다.
    return this.props.embedded ? content : (
      <div id="page-wrapper">
        {content}
      </div>
    );
  }
}

export default InstagramAiVideoStudioStarter;
